import {useMemo} from 'react'
import {useQuery} from 'react-query'
import {productUseCase} from '../../factories'

const useGetRecommended = (variables, expandedFilter) => {
    const recommended = useQuery(
        ['recommendedLamp', variables],
        ({queryKey}) => productUseCase.getRecommended(queryKey[1]),
        {
            refetchOnWindowFocus: false,
            keepPreviousData: true,
        }
    )
    const expandedVariables = {
        ...variables,
        condition: {
            ...variables.condition,
            filter: expandedFilter,
            filterMin: expandedFilter,
        },
    }
    const expanded = useQuery(
        ['recommendedLamp', expandedVariables],
        ({queryKey}) => productUseCase.getRecommended(queryKey[1]),
        {enabled: !!expandedFilter, refetchOnWindowFocus: false}
    )
    const originalData = recommended.data
    const expandedData = expandedFilter ? expanded.data : undefined
    const data = useMemo(() => {
        if (!expandedData) return originalData
        if (!originalData) return expandedData

        // Preserve the original recommendations, including any server fallback results.
        const records = new Map()
        for (const item of [...originalData.data.data, ...expandedData.data.data]) {
            if (!records.has(item.id)) records.set(item.id, item)
        }
        return {
            ...originalData,
            data: {...originalData.data, data: [...records.values()]},
        }
    }, [originalData, expandedData])

    const refetch = (options) => Promise.all([
        recommended.refetch(options),
        ...(expandedFilter ? [expanded.refetch(options)] : []),
    ])

    return {
        refetch,
        isFetching: recommended.isFetching || (!!expandedFilter && expanded.isFetching),
        isLoading: recommended.isLoading,
        error: recommended.error || (expandedFilter ? expanded.error : null),
        data
    }
}

export default useGetRecommended
